export const styles = {
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
  },
  breadcrumbsText: {
    fontSize: ' 16px',
    color: '#707087',
    marginLeft: '10px',
    cursor: 'pointer',
    textDecoration: 'none !important',
  },
  arrow: {
    margin: '0 18px',
    '& svg': {
      height: '10px',
    },
  },
  mainIcon: {
    marginRight: '10px',
  },
  lastBreadcrumb: {
    fontSize: '16px',
    color: '#707087',
    marginLeft: '10px',
  },
}
